import {
  OrderedMap as ImmutableOrderedMap,
  Map as ImmutableMap
} from 'immutable';

function filterNonExistentObjectValues(
  object,
  {
    shouldFilterEmptyStrings = false,
  } = {}
) {
  let filteredObject = {};

  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const value = object[key];

      if (value !== null &&
        typeof value !== 'undefined' &&
        (!shouldFilterEmptyStrings || value !== '')) {
        filteredObject[key] = value;
      }
    }
  }

  return filteredObject;
}

function defaultFromArrayToMapTransformer(accMap, element, config) {
  const {propertyName} = config;

  accMap.set(element[propertyName], element);

  return accMap;
}

function fromArrayToMapTransformerForIntegerKeys(accMap, element, config) {
  const {propertyName} = config;

  accMap.set(parseInt(element[propertyName], 10), element);

  return accMap;
}

function defaultFromObjectToMapTransformer(map, key, obj) {
  return map.set(key, obj[key]);
}

const defaultFromObjectToImmutableMapConfig = {
  transformer: defaultFromObjectToMapTransformer,
};

const defaultFromArrayToImmutableMapConfig = {
  transformer: defaultFromArrayToMapTransformer,
  propertyName: 'id',
};

function createImmutableMapFromSequentialCollection(sequentialCollection, config = {}) {
  const finalConfig = {
    ...defaultFromArrayToImmutableMapConfig,
    ...config,
  };
  const {transformer} = finalConfig;

  let immutableMap = ImmutableMap();

  immutableMap = immutableMap.asMutable();
  immutableMap = sequentialCollection.reduce((acc, element) => transformer(acc, element, finalConfig), immutableMap);
  immutableMap = immutableMap.asImmutable();

  return immutableMap;
}

function createImmutableMapFromObject(obj, config = {}, useOrderedMap) {
  const finalConfig = {
    ...defaultFromObjectToImmutableMapConfig,
    ...config,
  };
  const {transformer} = finalConfig;

  let map = useOrderedMap ? ImmutableOrderedMap() : ImmutableMap();

  map = map.withMutations((mutableMap) => {
    Object.keys(obj).
      forEach((key) => {
        transformer(mutableMap, key, obj);
      });
  });

  return map;
}

function createImmutableMapFromArray(array, config = {}) {
  return createImmutableMapFromSequentialCollection(array, config);
}

function createImmutableMapFromList(list, config = {}) {
  return createImmutableMapFromSequentialCollection(list, config);
}

function concatArrays(arrays) {
  return [].concat(...arrays);
}

function mapMap(map, handler) {
  const entriesArray = Array.from(map.entries());

  return entriesArray.map(([key, value]) => handler(value, key));
}

function createObjectFromStringArray(array, defaultValue = null) {
  return array?.reduce((o, v) => {
    o[v] = defaultValue;
    return o;
  }, {});
}

export {
  filterNonExistentObjectValues,
  createImmutableMapFromObject,
  createImmutableMapFromArray,
  createImmutableMapFromList,
  fromArrayToMapTransformerForIntegerKeys,
  concatArrays,
  mapMap,
  createObjectFromStringArray,
};
